module.exports = __webpack_public_path__ + "static/img/home-suggest-fire.8eaef3a1.png";